import type { PropsWithChildren } from 'react'
import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

export const InlineDetailsContainer = styled.div`
  > * + *::before {
    content: '·';
    margin: 0 ${rem(4)};
    speak-as: bullets;
    speak: none;
  }
`

type Props = PropsWithChildren<{}>

export default function LesaPurchaseSummarySeparator(props: Props) {
  const { children } = props

  return (
    <InlineDetailsContainer>
      {children}
    </InlineDetailsContainer>
  )
}
